var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifiAccessMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "896.901px",
    height: "896.9px",
    fill: "#008000",
    viewBox: "0 0 896.901 896.9",
    style: {
      enableBackground: "new 0 0 896.901 896.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 448.84,
    cy: 506.199,
    r: 46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.14,392.5l61.1,59.1c19.7-20.4,46.2-31.7,74.601-31.7c27.7,0,53.799,10.8,73.399,30.401L582.34,390.2 c-35.701-35.7-83.102-55.3-133.5-55.3C397.239,334.9,349.04,355.3,313.14,392.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.84,291.9c61.5,0,119.399,23.8,163.1,67.1l59.799-60.399c-59.699-59.2-138.898-91.7-222.899-91.7 c-42.7,0-84.2,8.4-123.3,24.9c-37.7,16-71.601,38.8-100.7,67.9l60.1,60.101C328.739,316,386.939,291.9,448.84,291.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.14,485.6c36,107.701,121.9,265.1,326.5,411.301c204.599-146.301,290.4-303.6,326.4-411.301 c16.301-40,25.4-83.6,25.801-129.299c0.1-2.101-0.201-3.4-0.201-3.7c0,0,0,0,0-0.101c0-194.7-157.6-352.5-352.2-352.5 c-194.7,0-352.4,157.8-352.4,352.5c0,0,0,1.301,0.1,3.801C96.64,402,105.84,445.6,122.14,485.6z M448.64,86.9 c150,0,271.599,121.6,271.599,271.6c0,150-121.6,271.6-271.599,271.6c-150,0-271.6-121.6-271.6-271.6 C177.04,208.5,298.64,86.9,448.64,86.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiAccessMarker);
export default __webpack_public_path__ + "static/media/wifi-access-marker.007047b1396edf1776a3df059692b3b7.svg";
export { ForwardRef as ReactComponent };